<template>
    <van-nav-bar 
        :title="title"
        left-arrow
        @click-left="$router.go(-1)"
    />
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:""
        },
    }
}
</script>

<style scoped>
    .van-nav-bar {
        background: #22d8d9;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        color: #ffffff;
        z-index: 100;
    }
</style>